module.exports = __webpack_public_path__ + "static/media/YM37_2.3b4adf2b.jpg";